import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomPaginatorComponent } from './custom-paginator.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [CustomPaginatorComponent],
  imports: [TranslateModule, CommonModule, FormsModule, ReactiveFormsModule],
  exports: [TranslateModule, CustomPaginatorComponent]
})
export class CustomPaginatorModule { }
